export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-geo/src/constant.js
// module id = 919
// module chunks = 1